/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Byoa_Field_LabelInputs */

const en_byoa_field_label = /** @type {(inputs: Byoa_Field_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connection name`)
};

const id_byoa_field_label = /** @type {(inputs: Byoa_Field_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama koneksi`)
};

/**
* | output |
* | --- |
* | "Connection name" |
*
* @param {Byoa_Field_LabelInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const byoa_field_label = /** @type {((inputs?: Byoa_Field_LabelInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Byoa_Field_LabelInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_byoa_field_label(inputs)
	return en_byoa_field_label(inputs)
});